var moduleMap = {
	"./FleetView": () => {
		return Promise.all([__webpack_require__.e(755), __webpack_require__.e(410), __webpack_require__.e(753), __webpack_require__.e(769), __webpack_require__.e(901), __webpack_require__.e(803), __webpack_require__.e(740)]).then(() => (() => ((__webpack_require__(2740)))));
	},
	"./VehicleExpandedView": () => {
		return Promise.all([__webpack_require__.e(755), __webpack_require__.e(410), __webpack_require__.e(901), __webpack_require__.e(803), __webpack_require__.e(846)]).then(() => (() => ((__webpack_require__(43846)))));
	},
	"./VehicleTileView": () => {
		return Promise.all([__webpack_require__.e(755), __webpack_require__.e(410), __webpack_require__.e(753), __webpack_require__.e(901), __webpack_require__.e(803), __webpack_require__.e(855)]).then(() => (() => ((__webpack_require__(80855)))));
	},
	"./ServiceBookingWidget": () => {
		return Promise.all([__webpack_require__.e(755), __webpack_require__.e(651), __webpack_require__.e(901), __webpack_require__.e(371)]).then(() => (() => ((__webpack_require__(28371)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});